export const environment = {
  production: false,
  name: "cbrtauat",
  version: '20231027.2',
  
  iCBMSWebApi: {
    url: "https://icbmsuat.cbrta.co.za:90/api/",
    systemCode: "ICBMS",
    userData: null
  },
  consoleAPIUrl : "http://localhost:5050",
  powerBIUrl: "https://icbmsuat.cbrta.co.za:100",
  payGateApi: {
    url: 'https://icbmsuat.cbrta.co.za:4433/PayGateApi',
    icbmsUrl: 'https://icbmsuat.cbrta.co.za:90/api/paygate',
    returnUrl:'https://icbmsuat.cbrta.co.za:90/api/paygate/payment-done/',
    paygateUrl: 'https://secure.paygate.co.za/payweb3/process.trans'
  },
  authWebApi: {
    url: "https://icbmsuat.cbrta.co.za:81",
    client:"https://icbmsuat.cbrta.co.za:82",
    systemCode: "ICBMS",
    userData: null,
    systemData: null
  }
  , workflowApi:
  {
    url: "https://icbmsuat.cbrta.co.za:99/api/"

  }
  , captcha: {
    siteKey:"6LfUH88ZAAAAANOajW5BzyUDB3ypzJOoZIaSTwh1"
  }
  , activateLink: {
    url:"https://icbmsuat.cbrta.co.za/activate"
  },
  extractToView: {
    url: "https://icbmsuat.cbrta.co.za:85/"
  },
  azure:{
    redirectUri:'https://icbmsuat.cbrta.co.za'
  },
  APIKey:{
    MAPKey:"AIzaSyAyo0cn5IvZ2gpS2B-mCYKUQb3SJtMdZw8",
    GeoCoordKey:"AIzaSyAtS5r1KDlZjQGbMDQuANdAicl7WTL-sI8",
    TempKey : "AIzaSyA54CFqo-JeybZpnkxUkRgSsysBV-40l18"
  }
};
